// FAR-85: the Admin Users tab, on the real user records (models.User):
//   { id, email, displayName, roles: [{ role, plant }], defaultPlant, lastLogin }
// Pure, so the shape handling is tested without a browser.

export const ROLE_ORDER = ['Admin', 'Planner', 'Approver', 'Viewer']

// The name to show: the display name, else the email, else the id.
export function displayNameOf(user) {
  const n = String(user?.displayName || '').trim()
  if (n) return n
  return String(user?.email || user?.id || 'Unknown user')
}

// Up to two initials from the shown name ("tyler" -> "T", "Mark Van Driel" -> "MV",
// "a@b.c" -> "A"). Never throws on a missing name.
export function initialsOf(user) {
  const words = displayNameOf(user).split(/[\s@._-]+/).filter(Boolean)
  return words.slice(0, 2).map((w) => w[0]).join('').toUpperCase() || '?'
}

// Role assignments as {role, plant}; tolerates the old string form.
export function roleAssignments(user) {
  return (user?.roles || []).map((r) => (typeof r === 'string' ? { role: r, plant: '' } : { role: r?.role || '', plant: r?.plant || '' }))
    .filter((r) => r.role)
}

// "Admin · 1002" chips, roles in a stable order.
export function roleChips(user, plantName = (c) => c) {
  const rank = (r) => {
    const i = ROLE_ORDER.findIndex((x) => x.toLowerCase() === r.toLowerCase())
    return i < 0 ? ROLE_ORDER.length : i
  }
  return roleAssignments(user)
    .sort((a, b) => rank(a.role) - rank(b.role) || a.plant.localeCompare(b.plant))
    .map((r) => ({ key: `${r.role}@${r.plant}`, role: r.role, label: r.plant ? `${r.role} · ${plantName(r.plant)}` : r.role }))
}

// The plant shown in "Default Plant": the stored default, else the only plant
// the user has a role at.
export function defaultPlantOf(user) {
  if (user?.defaultPlant) return user.defaultPlant
  const plants = [...new Set(roleAssignments(user).map((r) => r.plant).filter(Boolean))]
  return plants.length === 1 ? plants[0] : ''
}

export function sortUsers(users) {
  return [...(users || [])].sort((a, b) => displayNameOf(a).localeCompare(displayNameOf(b)))
}
